import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Login from './views/Login';
import ForgotPassword from './views/forgotPassword';
import ResetPassword from './views/resetPassword';
import ExpiredPassword from './views/expiredPassword';
import { queryToObj } from './utils/query';

function App() {
    useEffect(() => {
        if (window.location.search) {
            let query = queryToObj(window.location.search);

            if (query.token) {
                localStorage.setItem('jwt_access_token', query.token);
            }
        }
    }, []);

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Login} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route path="/reset-password" component={ResetPassword} />
                <Route path="/expired-password" component={ExpiredPassword} />
                <Route component={Login} />
            </Switch>
        </BrowserRouter>
    );
}

export default App;
